import type { HttpErrorResponse } from '@angular/common/http';

import { createEntityCollectionStore, type PickActions, pipeState } from '@core/ngrx-legacy';
import type { AskPredefinedTemplate } from '@tellent-ask-hr/templates-types';

const idSelector = (template: { name: string }) => template.name;
const { selectors, reducer, actions, namespace } =
  createEntityCollectionStore<AskPredefinedTemplate>()('AskPredefinedTemplates', {
    idSelector,
    customActions: adapter => ({
      fetchPredefined: state => adapter.markAsPending(state, { scope: 'predefined', entities: [] }),
      fetchPredefinedSuccess: (state, payload: { data: AskPredefinedTemplate[] }) =>
        pipeState(
          state,
          next =>
            adapter.markAsLoaded(next, {
              scope: 'predefined',
              entities: payload.data.map(idSelector),
            }),
          next =>
            adapter.setMany(next, payload.data, {
              scope: 'predefined',
            }),
        ),
      fetchPredefinedFailed: (state, payload: { error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error),
    }),
  });

const AskPredefinedTemplatesActions: PickActions<typeof actions, 'fetchPredefined'> = actions;

export {
  selectors as AskPredefinedTemplatesSelectors,
  reducer as AskPredefinedTemplatesReducer,
  AskPredefinedTemplatesActions,
  namespace as AskPredefinedTemplatesNamespace,
};
